 <template>
  <div>
    <success-fade-alert ref="alert" msg="Registro cadastrado com sucesso" />
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row>
      <b-col>
        <h2>{{ $t("checklist.form.creation") }}</h2>
        <b-button @click="voltar()" size="sm">
          {{ $t("geral.back") }}
        </b-button>
      </b-col>
    </b-row>

    <b-row style="margin-top: 30px">
      <b-col lg="6" md="6" sm="6">
        <!-- OriginStateId -->
        <b-form-group
          :label="$t('tracking.cargo.originState')"
          label-for="OriginStateId"
        >
          <b-form-select
            id="OriginStateId"
            v-model="originStateId"
            :options="optionsState"
          />
        </b-form-group>

        <!-- OriginCityId -->
        <b-form-group
          :label="$t('tracking.cargo.originCity')"
          label-for="OriginCityId"
        >
          <city-dropdown
            id="OriginCityId"
            :state-id="parseInt(originStateId)"
            :city-id="originCityId"
            :changeData.sync="originCityId"
          />
          <span class="text-danger" v-if="modelstate['OriginCityId']">
            {{ modelstate["OriginCityId"][0] }}
          </span>
        </b-form-group>

        <!-- DestinationStateId -->
        <b-form-group
          :label="$t('tracking.cargo.destinationState')"
          label-for="DestinationStateId"
        >
          <b-form-select
            id="DestinationStateId"
            :options="optionsState"
            v-model="destinationStateId"
          />
        </b-form-group>

        <!-- DestinationCityId -->
        <b-form-group
          :label="$t('tracking.cargo.destinationCity')"
          label-for="DestinationCityId"
        >
          <city-dropdown
            id="DestinationCityId"
            :state-id="parseInt(destinationStateId)"
            :city-id="destinationCityId"
            :changeData.sync="destinationCityId"
          />
          <span class="text-danger" v-if="modelstate['DestinyCityId']">
            {{ modelstate["DestinyCityId"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12" md="12" sm="12">
        <!-- AdditionalInfortion -->
        <b-form-group
          :label="$t('tracking.cargo.additionalInformation')"
          label-for="additionalInformation"
        >
          <b-form-textarea
            id="additionalInformation"
            :placeholder="$t('tracking.cargo.additionalInformation')"
            v-model="complement"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-button @click="savePath" size="sm">
      {{ $t("geral.save") }}
    </b-button>
  </div>
</template>
<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CityDropdown: () => import("@/components_rms/System/city/CityDropdown.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  props: {
    model: Object,
  },
  data() {
    return {
      modelstate: {},
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      optionsState: [{ value: null, text: "Carregando cidades" }],

      originStateId: null,
      destinationStateId: null,

      originCityId: null,
      destinationCityId: null,
      complement: "",
    };
  },
  created() {
    this.loadStates();
  },
  methods: {
    savePath() {
      this.modelstate = {};
      var obj = {
        OriginCityId: this.originCityId,
        DestinyCityId: this.destinationCityId,
        AdditionalInformation: this.complement,
      };
      this.$api
        .post("/create/", obj)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.$refs.alert.show();
          }
          this.clearFields();
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    loadStates() {
      this.$api
        .get("/state/getDropdownOptions")
        .then((response) => {
          this.optionsState = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    clearFields() {
      this.originStateId = null;
      this.destinationStateId = null;
      this.originCityId = null;
      this.destinationCityId = null;
      this.complement = "";
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>